













import { DevicePriceType } from '@ad/tt_ads_common_enums';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

const name = 'ttam-device-price';
export default defineComponent({
  name,
  props: {
    value: {
      type: Number as PropType<DevicePriceType>,
      default: DevicePriceType.ANY,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const _deviceType = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });

    return {
      name,
      _deviceType,
      deviceTypeOptions: ref(DevicePriceType),
    };
  },
});
